import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { integrationQueryKeys } from "@/integration/data/integrationQueryKeys";

export function useLinearConnection(options?: { enabled?: boolean }) {
  const { org } = useEnvironment();

  return useQuery({
    queryKey: integrationQueryKeys.linearConnection(org.id),
    queryFn: () =>
      api
        .get<"/orgs/:orgId/linear/connection">(
          `/orgs/${org.id}/linear/connection`,
        )
        .then((res) => res.data),
    enabled: Boolean(org) && options?.enabled !== false,
    retry: false,
    retryOnMount: false,
    staleTime: 1000 * 2, // 2 seconds to dedupe requests
  });
}
